module.exports = __webpack_public_path__ + "img/IBladeChariot64_ua.7dbe0b8c.webp";